import { error } from "console";
import { ReactNode } from "react";

export const getErrorMessages = (errorMsg): string[] => {
  if (!errorMsg) return [];

  // If it's a string, return it as a single item array
  if (typeof errorMsg === "string") return [errorMsg];

  // If it's an array, flatten it and filter out non-strings
  if (Array.isArray(errorMsg)) {
    return errorMsg.flatMap((msg) => getErrorMessages(msg));
  }

  // If it's an object, recursively get messages from all values
  if (typeof errorMsg === "object") {
    return Object.values(errorMsg).flatMap((value) => getErrorMessages(value));
  }

  return [];
};

export const displayErrorMessages = (errorMsg: string[] | null): ReactNode => {
  if (!errorMsg || errorMsg.length === 0) return null;

  if (errorMsg.length === 1) return errorMsg[0];

  return (
    <ul>
      {getErrorMessages(errorMsg).map((msg, index) => (
        <li key={index}>{msg}</li>
      ))}
    </ul>
  );
};
